import { courseEndpoints } from "@/config/endpoints";
import axiosInstance from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";

export default function useCurrentCourse(courseId: number | null | undefined) {
  const query = useQuery({
    queryKey: ["get-course", courseId],
    queryFn: async () => {
      if (!courseId) return null;

      const res = await axiosInstance.get(`${courseEndpoints}/${courseId}`);
      return res.data.course;
    },
  });

  return {
    course: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
